import {
  FC, useContext, useEffect, useMemo, useState,
} from 'react';

import {
  Content,
  FlipText, KioskRoot, LabelWrapper,
} from 'components/_Footer/index.styled';
import ShoppingCart from 'components/ShoppingCart';
import { CartContext } from 'context/CartContext';

import { useKiosk } from 'hooks/useKiosk';

import { addToCartSped } from 'constants/general';
import { calculateTotalQuantity } from 'utils/cartUtils';

const KioskFooter:FC = () => {
  const { managementMode } = useKiosk();
  const { kioskLabel, products } = useContext(CartContext);
  const totalProductsQuantity = useMemo(() => calculateTotalQuantity(products), [products]);

  const [currentLabel, setCurrentLabel] = useState(kioskLabel);
  const [isFlipping, setIsFlipping] = useState(false);
  const [currentQuantity, setCurrentQuantity] = useState(totalProductsQuantity);
  const [increaseZindex, setIncreaseZIndex] = useState(false);

  useEffect(() => {
    if (totalProductsQuantity !== currentQuantity) {
      setCurrentQuantity(totalProductsQuantity);
      setIncreaseZIndex(true);

      setTimeout(() => setIncreaseZIndex(false), addToCartSped * 1.5);
    }
  }, [totalProductsQuantity, totalProductsQuantity]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (kioskLabel !== currentLabel) {
      setIsFlipping(true);

      const timeout = setTimeout(() => {
        setCurrentLabel(kioskLabel);
        setIsFlipping(false);
      }, 400);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [kioskLabel]);

  return (
    <KioskRoot managementMode={managementMode}>
      <Content increaseZindex={increaseZindex}>
        <LabelWrapper className="label">
          <FlipText
            variant="body2"
            fontWeight={700}
            className="headerBackground"
            {...(isFlipping ? { animateOut: true } : { animateIn: true })}
          >
            {currentLabel}
          </FlipText>
        </LabelWrapper>
        <ShoppingCart />
      </Content>
    </KioskRoot>
  );
};

export default KioskFooter;
